import { timeInStatusTiers, timeInStatusTierLabels } from './timeInStatusConsts';
import { useTimeInStatusBadgeStyles } from './TimeInStatusBadgeStyles';

export const TimeInStatusBadge = ({ tier }) => {
    const classes = useTimeInStatusBadgeStyles();
    const tierClass = classes?.[`tier${tier}`] ?? classes?.[`tier${timeInStatusTiers.NoThreshold}`];
    const label = timeInStatusTierLabels[tier] ?? timeInStatusTierLabels[timeInStatusTiers.NoThreshold];

    return <span className={`${classes.badge} ${tierClass}`}>{label}</span>;
};

export default TimeInStatusBadge;
